import { createFileRoute } from '@tanstack/react-router';
import { StationTypesClient } from '@/features/storage/StationTypesClient';

export const Route = createFileRoute('/_shell/storage/station-types')({
  component: StationTypesClient,
});
